/**
 * Centralized Translation Management
 * This file handles manual translations for dynamic content that external apps (like T Lab) cannot reach.
 * It is loaded globally to ensure all components have access to the same translation data.
 */

window.themeTranslations = {
    currentLocale: 'en', // Default, will be updated by script

    // Dictionary of all translations, grouped by key for easier management
    // Format: key: { 'en': 'English Text', 'nl': 'Dutch Text' }
    resources: {
        //
        // HERO SEARCH SECTION
        //
        'hero_main_title': {
            'en': 'Japan eSIM and travel eSIM for 190+ countries.',
            'nl': 'Japan eSIM en reis-eSIM voor 190+ landen.',
            'tr': 'Japonya eSIM ve 190\'dan fazla ülke için seyahat eSIM paketleri.'
        },
        'hero_search_label': {
            'en': 'Get started. <br>Your eSIM awaits.',
            'nl': 'Start hier. <br>Je eSIM voor elke reis.',
            'tr': 'Buradan başla. <br>Her seyahat için eSIM.'
        },
        'search_placeholder': {
            'en': 'Type a country',
            'nl': 'Zoek je bestemming',
            'tr': 'Gideceğin ülkeyi yaz'
        },
        'hero_search_sublabel': {
            'en': '...and we\'ll get you travel ready <br>in seconds.',
            'nl': '...en we maken je binnen <br>seconden reisklaar.',
            'tr': '...ve seni saniyeler içinde seyahate <br>hazır hale getirelim.'
        },
        'choose_plan_subtitle': {
            'en': 'Choose a set amount of data,<br>or stay connected with unlimited data.',
            'nl': 'Kies een vaste hoeveelheid data,<br>of blijf verbonden met onbeperkte data.',
            'tr': 'Belirli bir miktar internet seç<br>veya sınırsız internetle bağlantıda kal.'
        },
        'whats_difference': {
            'en': "What's the difference?",
            'nl': 'Wat is het verschil?',
            'tr': 'Aradaki fark ne?'
        },
        'almost_set_title': {
            'en': "You're almost set.",
            'nl': 'Bijna klaar.',
            'tr': 'Neredeyse hazırsın.'
        },
        'set_days_quantity': {
            'en': 'Set your days and quantity.',
            'nl': 'Kies je aantal dagen en eSIMs.',
            'tr': 'Gün sayısını ve eSIM adedini seç.'
        },
        'set_quantity': {
            'en': 'Set your quantity.',
            'nl': 'Kies je aantal eSIMs.',
            'tr': 'eSIM adedini seç.'
        },
        'days_label': {
            'en': 'Days',
            'nl': 'Dagen',
            'tr': 'Gün'
        },
        'esims_label': {
            'en': 'eSIMs',
            'nl': 'eSIMs',
            'tr': 'eSIM'
        },
        'fixed_plan': {
            'en': 'Fixed Plan',
            'nl': 'Vast plan',
            'tr': 'Sabit Paket'
        },
        'daily_plan': {
            'en': 'Unlimited Plan',
            'nl': 'Onbeperkt plan',
            'tr': 'Sınırsız Paket'
        },
        'unlimited_custom_days': {
            'en': 'Custom days',
            'nl': 'Dagen op maat',
            'tr': 'Kendin belirle'
        },
        'unlimited_days_label': {
            'en': '# days Unlimited',
            'nl': '# dagen Onbeperkt',
            'tr': '# gün Sınırsız'
        },
        // Word-level tokens used to translate raw Storefront variant option
        // text (e.g. "Unlimited", "3 days") at render time only — the
        // underlying English values are kept for day-count/"Plus" parsing.
        'variant_label_unlimited_word': {
            'en': 'Unlimited',
            'nl': 'Onbeperkt',
            'tr': 'Sınırsız'
        },
        'variant_label_day_singular': {
            'en': 'day',
            'nl': 'dag',
            'tr': 'gün'
        },
        'variant_label_day_plural': {
            'en': 'days',
            'nl': 'dagen',
            'tr': 'gün'
        },
        'unlimited_speed_note': {
            'en': '2 GB/day full speed, then 1 Mbps.',
            'nl': '2 GB/dag hoge snelheid, daarna 1 Mbps.',
            'tr': '2 GB/gün yüksek hız, sonra 1 Mbps.'
        },
        'choose_your_pack': {
            'en': 'Choose your Plan',
            'nl': 'Kies je Plan',
            'tr': 'Planını seç'
        },
        'choose_your_pack_detail': {
            'en': 'Choose your Pack',
            'nl': 'Kies je Bundel',
            'tr': 'Paketini seç'
        },
        'title_prefix_for': {
            'en': 'for',
            'nl': 'voor',
            'tr': 'için'
        },
        'with_network_singular': {
            'en': 'With top local network',
            'nl': 'Aangesloten op lokaal netwerk',
            'tr': 'Önde gelen yerel ağa bağlı'
        },
        'with_network_plural': {
            'en': 'With top local networks',
            'nl': 'Aangesloten op lokale netwerken',
            'tr': 'Önde gelen yerel ağlara bağlı'
        },
        'continue': {
            'en': 'Continue',
            'nl': 'Verder',
            'tr': 'Devam et'
        },
        'view_product': {
            'en': 'Product page',
            'nl': 'Productpagina',
            'tr': 'Ürün sayfası'
        },
        'no_matching_countries': {
            'en': 'No countries found',
            'nl': 'Geen landen gevonden',
            'tr': 'Eşleşen ülkeler bulunamadı'
        },
        'info_topup_available': {
            'en': 'Top up anytime',
            'nl': 'Opwaarderen mogelijk',
            'tr': 'Ek paket alınabilir'
        },
        'info_topup_unavailable': {
            'en': 'Unlimited Data',
            'nl': 'Onbeperkte Data',
            'tr': 'Sınırsız Data'
        },
        'info_speed_stop': {
            'en': 'No throttling',
            'nl': 'Data stopt na je bundel',
            'tr': 'Paket bitince internet durur'
        },
        'info_speed_slow': {
            'en': 'Throttling after limit',
            'nl': 'Lagere snelheid na daglimiet',
            'tr': 'Günlük limit sonrası hız düşer'
        },
        'info_start_arrival': {
            'en': 'Activation can be delayed',
            'nl': 'Activatie kan worden uitgesteld',
            'tr': 'Aktivasyon ertelenebilir'
        },
        'info_hotspot': {
            'en': 'Hotspot supported',
            'nl': 'Hotspot beschikbaar',
            'tr': 'Hotspot kullanılabilir'
        },
        'info_local_networks': {
            'en': 'Local networks',
            'nl': 'Lokale netwerken',
            'tr': 'Yerel operatörler'
        },
        'login_title': {
            'en': 'Create an account or log in.',
            'nl': 'Aanmelden of inloggen.',
            'tr': 'Hesap oluştur veya giriş yap.'
        },
        'login_subheader': {
            'en': 'One process for both. Choose a quick login below.',
            'nl': 'Één proces voor beiden. Kies hieronder een sneltoets.',
            'tr': 'İkisi için tek işlem. Hızlı giriş için aşağıdan seç.'
        },
        'applying': {
            'en': 'Applying...',
            'nl': 'Toepassen...',
            'tr': 'Uygulanıyor...'
        },
        'select_device_type': {
            'en': 'Select Device Type',
            'nl': 'Kies toesteltype',
            'tr': 'Cihaz türünü seç'
        },
        'loading': {
            'en': 'Loading...',
            'nl': 'Laden...',
            'tr': 'Yükleniyor...'
        },
        'tl_currency': {
            'en': 'Currency',
            'nl': 'Valuta',
            'tr': 'Para Birimi'
        },
        'tl_language': {
            'en': 'Language',
            'nl': 'Taal',
            'tr': 'Dil'
        }
    },

    /**
     * Get a translated string by key
     * @param {string} key - The translation key
     * @returns {string} The translated string or the key if not found
     */
    t: function (key) {
        // Determine locale if not set
        if (!this.currentLocale) {
            this.detectLocale();
        }

        // Default to 'en' if the locale is not one of our supported ones
        const locale = (this.currentLocale === 'nl' || this.currentLocale === 'tr') ? this.currentLocale : 'en';

        // Check if key exists in our grouped resources
        if (this.resources[key]) {
            // Check if translation for current locale exists
            if (this.resources[key][locale]) {
                return this.resources[key][locale];
            }
            // Fallback to English if current locale translation is missing
            if (this.resources[key]['en']) {
                return this.resources[key]['en'];
            }
        }

        // Return key as fallback
        return key;
    },

    /**
     * Detect the current locale from the document or window
     */
    detectLocale: function () {
        let locale = 'en'; // default

        // Check HTML generic lang attribute (set by translation apps like T Lab)
        if (document.documentElement.lang) {
            locale = document.documentElement.lang.split('-')[0].toLowerCase();
        } else if (window.currentLocale) {
            locale = window.currentLocale;
        }

        // If locale is not supported, default to 'en'
        if (locale !== 'nl' && locale !== 'tr' && locale !== 'en') {
            locale = 'en';
        }

        this.currentLocale = locale;
        return locale;
    },

    /**
     * Initialize and observe language changes
     */
    init: function () {
        this.detectLocale();

        // Listen for language changes via mutation observer on html lang attribute
        const langObserver = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'lang') {
                    const newLang = document.documentElement.lang.split('-')[0].toLowerCase();
                    if (this.currentLocale !== newLang) {
                        console.log(`🌍 Language changed to ${newLang}`);
                        this.currentLocale = newLang;

                        // Trigger a custom event for other scripts to listen to
                        document.dispatchEvent(new CustomEvent('theme:language:changed', {
                            detail: { locale: newLang }
                        }));

                        // Re-apply translations
                        this.applyDynamicTranslations();
                    }
                }
            });
        });

        langObserver.observe(document.documentElement, { attributes: true });

        // Initial application
        // Wait for DOM content loaded if not already
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.applyDynamicTranslations());
        } else {
            this.applyDynamicTranslations();
        }
    },

    /**
     * Apply translations to dynamic elements like Klaviyo forms
     */
    applyDynamicTranslations: function () {
        // Login page title
        const loginTitle = document.getElementById('login-title');
        if (loginTitle) {
            const translatedTitle = this.t('login_title');
            if (translatedTitle && translatedTitle !== 'login_title') {
                loginTitle.innerHTML = translatedTitle;
            }
        }

        // Login page subheader
        const loginSubheader = document.getElementById('login-subheader');
        if (loginSubheader) {
            const translatedSubheader = this.t('login_subheader');
            if (translatedSubheader && translatedSubheader !== 'login_subheader') {
                loginSubheader.innerHTML = translatedSubheader;
            }
        }

        // Compatibility select device type title
        const deviceTypeLabels = document.querySelectorAll('.compatibility-variant-label');
        if (deviceTypeLabels.length > 0) {
            const translatedDeviceType = this.t('select_device_type');
            if (translatedDeviceType && translatedDeviceType !== 'select_device_type') {
                deviceTypeLabels.forEach(label => {
                    label.innerHTML = translatedDeviceType;
                });
            }
        }

        // T-Lab specific titles
        const allTlTitles = document.querySelectorAll('.tl-title');
        if (allTlTitles.length > 0) {
            const translatedCurrency = this.t('tl_currency');
            const translatedLanguage = this.t('tl_language');

            allTlTitles.forEach(title => {
                // If preceded by .tl-switcher, it is the language title
                if (title.previousElementSibling && title.previousElementSibling.classList.contains('tl-switcher')) {
                    if (translatedLanguage && translatedLanguage !== 'tl_language') {
                        title.innerHTML = translatedLanguage;
                    }
                } else {
                    // Otherwise it is the currency title
                    if (translatedCurrency && translatedCurrency !== 'tl_currency') {
                        title.innerHTML = translatedCurrency;
                    }
                }
            });
        }

    }
};

// Initialize immediately
window.themeTranslations.init();
